export default __webpack_public_path__ + "efe8b65c49807ee77c15d5e1b9a49d5b.png";